namespace RedBullMOBILE360.Settings {
    export class ServiceParametersColumns {
        static columnsKey = 'Settings.ServiceParameters';
    }
}